<div class="container p-4 px-xl-0 registration-container">
    <h1 class="text-uppercase">{{'logout.success.header' | translate }}</h1>
    <p class="mb-4"> {{'logout.success.headerText' | translate }}</p>
  
    <div class="row gap-3 py-2">
      <button class="col-120 col-lg-auto btn btn-secondary" (click)="toHomepage()">
        {{'logout.success.toHomepage' | translate }}
      </button>
      <button class="col-120 col-lg-auto btn btn-primary" (click)="login()">
        {{'logout.success.toLogin' | translate }}
      </button>
    </div>
  </div>
  